module.exports = __webpack_public_path__ + "static/media/b2.ea0afeb2.png";